import CodeDesc from '../../code-desc';
import WarehouseSelect from '../../warehouse-select';
import or from 'ember-truth-helpers/helpers/or';

import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export interface ISkusWarehouseFilterDefinitionArgs {
  skuId?: string;
  horizontalPosition?: 'left' | 'right' | 'auto';
  beforeQuery?: (query: IJsonApiQuery) => IJsonApiQuery;
}

const FiltersSkusWarehouseFilterComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <WarehouseSelect
    @values={{@values}}
    @onChange={{@onChange}}
    @beforeQuery={{@componentArgs.beforeQuery}}
    @selectedPath='code'
    @labelHidden={{true}}
    @fill={{true}}
    @multiple={{true}}
    @matchTriggerWidth={{true}}
    @triggerClass={{@triggerClass}}
    @horizontalPosition={{or @componentArgs.horizontalPosition @horizontalPosition}}
    @dataName={{@name}}
    ...attributes
    as |warehouse|
  >
    <CodeDesc @code={{warehouse.code}} @desc={{warehouse.description}} />
  </WarehouseSelect>
</template> satisfies TemplateOnlyComponent<ISkusWarehouseFilterDefinitionArgs>;

export default FiltersSkusWarehouseFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::SkusWarehouseFilter': typeof FiltersSkusWarehouseFilterComponent;
    'filters/skus-warehouse-filter': typeof FiltersSkusWarehouseFilterComponent;
  }
}
